import dayjs, { Dayjs } from "dayjs";
import {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from "react";

import SpecialistApi from "../../../../../api/specialistsApi";
import { ReactComponent as EditIcon } from "../../../../../assets/General/cloud-plus.svg";
import { ReactComponent as PlusIcon } from "../../../../../assets/General/plus.svg";
import Input from "../../../../../components/Input/Input";
import Loader from "../../../../../components/Loader/Loader";
import MuiDatePicker from "../../../../../components/MuiDatePicker/MuiDatePicker";
import MultipleSelect from "../../../../../components/MultipleSelect/MultipleSelect";
import StandartButton from "../../../../../components/StandartButton/StandartButton";
import {
  documentExtensions,
  imageExtensions,
} from "../../../../../constans/filesExtensions";
import { ContextProvider } from "../../../../../contextProvider";
import {
  Education,
  Federation,
  Qualification,
  QualificationCertificatesResponse,
} from "../../../../../types/TypeSpecialist";
import { TypeUpdatedUserInfo } from "../../../../../types/TypeUsers";
import { compressFiles } from "../../../../../utils/compressionFile";
import { getTranslation } from "../../../../../utils/getTranslation";
import Notify, { SuccesNotify } from "../../../../../utils/toaster";
import { CertificatesData } from "../../EducationSection";
import s from "../UpdateCertificatesModal.module.css";

type FederationsCertificates = {
  selectData: {
    education?: Education[];
    qualification?: Qualification[];
    federation?: Federation[];
  };
  setActionLoaders: Dispatch<SetStateAction<{ addedCertificate: boolean }>>;
  specialistId: string;
  specialization: string;
  setModalOpen: Dispatch<SetStateAction<boolean>>;
  setNewCertificate?: Dispatch<SetStateAction<CertificatesData>>;
  setupUpdateCertificate?: (cert: any) => void;
  actionLoaders: {
    addedCertificate: boolean;
  };
  setShowSendReviewRequestBtn?: Dispatch<SetStateAction<boolean>>;
  qualificationToUpdate?: QualificationCertificatesResponse;
};

type NewQualification = {
  newQualification: {
    qualificationText: string | undefined;
    federationText: string | undefined;
    badge: {
      file: File | undefined;
      url: string | undefined;
      qualificationId: string | undefined;
    };
  };
  qualificationToSave: {
    file: File | undefined;
    qualificationId: string | undefined;
    membershipStart: Date | undefined;
    membershipEnd: Date | undefined;
    federationProfileUrl: string | undefined;
  };
};

const initialQualification: NewQualification = {
  newQualification: {
    qualificationText: undefined,
    federationText: undefined,
    badge: {
      file: undefined,
      url: undefined,
      qualificationId: undefined,
    },
  },
  qualificationToSave: {
    file: undefined,
    qualificationId: undefined,
    membershipStart: undefined,
    membershipEnd: undefined,
    federationProfileUrl: undefined,
  },
};

const QualificationsCertificates = ({
  selectData,
  setActionLoaders,
  specialistId,
  specialization,
  setModalOpen,
  setNewCertificate,
  setupUpdateCertificate,
  actionLoaders,
  setShowSendReviewRequestBtn,
  qualificationToUpdate,
}: FederationsCertificates) => {
  const { userData } = useContext(ContextProvider);
  const token = localStorage.getItem("token");
  const [selectQualification, setSelectQualification] = useState<string>("");
  const [selectFederation, setSelectFederation] = useState<string>("");
  const [addQualification, setAddQualification] =
    useState<NewQualification>(initialQualification);
  const [qualificationsData, setQualificationsData] = useState<Qualification[]>(
    []
  );
  useEffect(() => {
    if (!qualificationToUpdate) return;
    setSelectFederation(qualificationToUpdate.qualification.federationRef._id);
    setSelectQualification(qualificationToUpdate.qualification._id);
    setAddQualification((prev) => ({
      ...prev,
      qualificationToSave: {
        ...prev.qualificationToSave,
        file: qualificationToUpdate.filename
          ? ({ name: qualificationToUpdate.filename } as File)
          : undefined,
      },
    }));
  }, [qualificationToUpdate]);

  const getQualifications = async (federationId: string) => {
    const response = await SpecialistApi.getQualifications(
      specialization,
      federationId,
      userData?.selectedLanguage
    );

    if (response.status && response.qualifications) {
      setQualificationsData(response.qualifications);
    }
  };
  useEffect(() => {
    if (!selectFederation.length || selectFederation === "other") return;
    getQualifications(selectFederation);
  }, [selectFederation]);

  const validateURL = (url: string | undefined) => {
    if (!url) return false;
    try {
      new URL(url);
      return true;
    } catch (e) {
      return false;
    }
  };

  const handleCertificateChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target && event.target.files) {
      const file = event.target.files[0];
      if (file && file.type.includes("pdf")) {
        setAddQualification((prev) => ({
          ...prev,
          qualificationToSave: {
            ...prev.qualificationToSave,
            file: file,
          },
        }));
      }
      if (file && !file.type.includes("pdf")) {
        const compressedFile = await compressFiles(file);
        if (compressedFile.file) {
          setAddQualification((prev) => ({
            ...prev,
            qualificationToSave: {
              ...prev.qualificationToSave,
              file: compressedFile.file,
            },
          }));
        }
      }
    }
  };

  /*   const handleBadgeIconChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target && event.target.files) {
      const file = event.target.files[0];

      if (file) {
        const compressedFile = await compressFiles(file);
        if (compressedFile.file) {
          setAddQualification((prev) => ({
            ...prev,
            newQualification: {
              ...prev.newQualification,
              badge: {
                ...prev.newQualification.badge,
                file: compressedFile.file,
              },
            },
          }));
        }
      }
    }
  }; */
  const createQualification = async (federationId: string) => {
    if (!token || !userData) return;
    const payload = {
      qualificationText: [
        {
          text: addQualification.newQualification.qualificationText!,
          language: userData.selectedLanguage!,
        },
      ],
      specialization: specialization,
      federationId: federationId,
    };
    const response = await SpecialistApi.createQualification(token, payload);
    return response.qualification?._id;
  };
  const createFederation = async () => {
    if (!token || !userData) return;
    const payload = {
      federationText: [
        {
          text: addQualification.newQualification.federationText!,
          language: userData.selectedLanguage!,
        },
      ],
      specialization: specialization,
    };
    const response = await SpecialistApi.createFederation(token, payload);
    return { status: response.status, federationId: response.federation?._id };
  };
  /*   const createFederationBadge = async () => {
    if (!token) return;
    const formData = new FormData();
    formData.append("file", addQualification.newQualification.badge.file!);
    formData.append("url", addQualification.newQualification.badge.url!);
    const response = await SpecialistApi.createFederationBadge(token, formData);
    return { status: response.status, badgeId: response.badge?._id };
  }; */

  const validationNewCertificate = () => {
    const qualificationToSave = addQualification.qualificationToSave;
    const newQualification = addQualification.newQualification;

    if (!selectQualification.length && !newQualification.qualificationText)
      return false;
    if (
      (!qualificationToUpdate && qualificationToSave.federationProfileUrl
        ? !validateURL(qualificationToSave.federationProfileUrl)
        : false) ||
      (!qualificationToUpdate && !qualificationToSave.membershipStart) ||
      (!qualificationToUpdate && !qualificationToSave.membershipEnd) ||
      (!qualificationToUpdate && !qualificationToSave.file)
    )
      return false;
    if (
      selectFederation === "other" &&
      (!newQualification.federationText ||
        !newQualification.federationText.length)
    )
      return false;
    if (
      (selectQualification === "other" || selectFederation === "other") &&
      (!newQualification.qualificationText ||
        !newQualification.qualificationText.length) /* ||
        !newQualification.badge.file ||
        !validateURL(newQualification.badge.url)) */
    )
      return false;
    return true;
  };

  useEffect(() => {
    if (
      !selectFederation ||
      (qualificationToUpdate &&
        selectFederation ===
          qualificationToUpdate.qualification.federationRef._id)
    )
      return;
    setSelectQualification("");
  }, [selectFederation]);

  const removeUndefined = (obj: Record<string, any>) => {
    return Object.fromEntries(
      Object.entries(obj).filter(([_, value]) => value !== undefined)
    );
  };

  const updateQualification = async () => {
    if (!token || !qualificationToUpdate) return;
    setActionLoaders((prev) => ({ ...prev, addedCertificate: true }));
    let qualificationId: string | undefined = undefined;
    let federationId: string | undefined = undefined;
    if (selectQualification && selectQualification !== "other") {
      qualificationId = selectQualification;
    }
    if (selectFederation === "other") {
      const createFederationResponse = await createFederation();
      federationId = createFederationResponse?.federationId;
    }
    if (selectFederation && selectFederation !== "other") {
      federationId = selectFederation;
    }
    if (
      federationId &&
      (selectFederation === "other" || selectQualification === "other")
    ) {
      qualificationId = await createQualification(federationId);
    }
    if (qualificationId) {
      const updateData = {
        ...addQualification.qualificationToSave,
        _id: qualificationToUpdate._id,
        qualification: qualificationId,
      };
      delete updateData.file;
      const payload = {
        file: addQualification.qualificationToSave.file?.size
          ? addQualification.qualificationToSave.file
          : undefined,
        specialistId: specialistId,
        updateData: removeUndefined(updateData) as TypeUpdatedUserInfo,
      };

      const mainResponse = await SpecialistApi.updateQualificationCertificate(
        payload,
        token
      );
      if (mainResponse.status) {
        setShowSendReviewRequestBtn && setShowSendReviewRequestBtn(true);
        SuccesNotify("Certificate has been updated");
        setAddQualification(initialQualification);
        setModalOpen(false);
        setSelectQualification("");
        setActionLoaders((prev) => ({ ...prev, addedCertificate: false }));
        setupUpdateCertificate &&
          setupUpdateCertificate(mainResponse.certificate);
        setNewCertificate &&
          setNewCertificate((prev) => ({
            ...prev,
            qualification: prev.qualification
              ? prev.qualification.map((item) => {
                  if (item._id === qualificationToUpdate._id) {
                    return mainResponse.certificate!;
                  }
                  return item;
                })
              : [mainResponse.certificate!],
          }));
      }
      if (!mainResponse.status && mainResponse.message) {
        Notify(mainResponse.message);
        setActionLoaders((prev) => ({ ...prev, addedCertificate: false }));
      }
    }
  };

  if (actionLoaders.addedCertificate) {
    return (
      <div className={s.loaderContainer}>
        <Loader size={100} />
      </div>
    );
  }

  return (
    <div className={`${s.container} ${s.federationContainer}`}>
      {selectData &&
        selectData.federation &&
        (selectFederation !== "other" ? (
          <MultipleSelect
            data={[
              ...(selectData.federation.map((item) => ({
                lable:
                  item.text.find(
                    (el) => el.language === userData?.selectedLanguage
                  )?.text ?? item.text[0].text,
                value: item._id,
              })) ?? []),
              ...(qualificationToUpdate &&
              !selectData.federation
                .map((item) => item._id)
                .includes(qualificationToUpdate.qualification.federationRef._id)
                ? [
                    {
                      lable: getTranslation(
                        qualificationToUpdate.qualification.federationRef.text,
                        "en"
                      ),
                      value:
                        qualificationToUpdate.qualification.federationRef._id,
                    },
                  ]
                : []),
              { lable: "Other", value: "other" },
            ]}
            multiplie={false}
            setValue={(value) => setSelectFederation(value as string)}
            value={selectFederation}
            padding="10px"
            lable={"Federation title"}
            margin="0 0 20px 0"
          />
        ) : (
          <div className={s.newFederationBlock}>
            <Input
              inputValue={
                addQualification.newQualification.federationText ?? ""
              }
              isVisible
              required
              onChangeInput={(value) =>
                setAddQualification((prev) => ({
                  ...prev,
                  newQualification: {
                    ...prev.newQualification,
                    federationText: value,
                  },
                }))
              }
              lable={"Federation title"}
              margin="0 0 20px 0"
              closeFunction={() => setSelectFederation("")}
            />
          </div>
        ))}
      {qualificationsData &&
        (selectQualification !== "other" && selectFederation !== "other" ? (
          <MultipleSelect
            data={[
              ...(qualificationsData.map((item) => ({
                lable:
                  item.text.find(
                    (el) => el.language === userData?.selectedLanguage
                  )?.text ?? item.text[0].text,
                value: item._id,
              })) ?? []),
              ...(qualificationToUpdate &&
              !qualificationsData
                .map((item) => item._id)
                .includes(qualificationToUpdate.qualification._id) &&
              qualificationToUpdate.qualification.federationRef._id ===
                selectFederation
                ? [
                    {
                      lable: getTranslation(
                        qualificationToUpdate.qualification.text,
                        "en"
                      ),
                      value: qualificationToUpdate.qualification._id,
                    },
                  ]
                : []),
              { lable: "Other", value: "other" },
            ]}
            multiplie={false}
            setValue={(value) => setSelectQualification(value as string)}
            value={selectQualification}
            padding="10px"
            lable={"Qualification"}
            disabled={!selectFederation.length ? true : false}
          />
        ) : (
          <div className={s.newFederationBlock}>
            <Input
              inputValue={
                addQualification.newQualification.qualificationText ??
                qualificationToUpdate?.federationProfileUrl ??
                ""
              }
              isVisible
              required
              onChangeInput={(value) =>
                setAddQualification((prev) => ({
                  ...prev,
                  newQualification: {
                    ...prev.newQualification,
                    qualificationText: value,
                  },
                }))
              }
              lable={"Qualification"}
              closeFunction={
                selectQualification === "other"
                  ? () => setSelectQualification("")
                  : undefined
              }
            />
            {/*  <Input
              inputValue={addQualification.newQualification.badge.url ?? ""}
              isVisible
              required
              onChangeInput={(value) =>
                setAddQualification((prev) => ({
                  ...prev,
                  newQualification: {
                    ...prev.newQualification,
                    badge: { ...prev.newQualification.badge, url: value },
                  },
                }))
              }
              lable={strings.badgeUrl}
              border={
                validateURL(addQualification.newQualification.badge.url) ||
                !addQualification.newQualification.badge.url ||
                !addQualification.newQualification.badge.url.length
                  ? "none"
                  : "1px solid red"
              }
              placeholder="https://www.credly.com/org/international-coach-federation/badge/icf-member-badge"
            />
            <div>
              <span className={s.secondLable}>{strings.badgeIcon}</span>
              <div className={s.uploadFilesActionBlock}>
                {addQualification.newQualification.badge.file && (
                  <img
                    src={URL.createObjectURL(
                      addQualification.newQualification.badge.file
                    )}
                    alt=""
                    className={s.badgeIcon}
                  />
                )}
                <label className={s.fileInputBlock}>
                  <input
                    style={{ display: "none" }}
                    type="file"
                   accept={imageExtensions.join(", ")}
                    multiple
                    onChange={handleBadgeIconChange}
                  />
                  {addQualification.newQualification.badge.file ? (
                    <span className={s.updateAvatarBtn} role="button">
                      <img src={EditIcon} alt="" />
                      <span>{strings.replace}</span>
                    </span>
                  ) : (
                    <div className={s.addCertificateBtn}>
                      <PlusIcon className={s.plusIcon} />
                      <span>{strings.addBadge}</span>
                    </div>
                  )}
                </label>
              </div>
            </div> */}
          </div>
        ))}
      <div className={s.inputBlock}>
        <Input
          inputValue={
            addQualification.qualificationToSave.federationProfileUrl ??
            qualificationToUpdate?.federationProfileUrl ??
            ""
          }
          isVisible
          required
          onChangeInput={(value) =>
            setAddQualification((prev) => ({
              ...prev,
              qualificationToSave: {
                ...prev.qualificationToSave,
                federationProfileUrl: value,
              },
            }))
          }
          lable={"Federation profile url/badge"}
          placeholder="https://apps.coachingfederation.org/eweb/CCFDynamicPage.aspx?webcode=ccfcoachprofileview&coachcstkey=A26D427B-86A3-4EE3-873E-D1468F4C48FB"
          border={
            validateURL(
              addQualification.qualificationToSave.federationProfileUrl
            ) ||
            !addQualification.qualificationToSave.federationProfileUrl ||
            !addQualification.qualificationToSave.federationProfileUrl.length
              ? "none"
              : "1px solid red"
          }
        />
      </div>
      <div className={s.dateBlock}>
        <span className={s.secondLable}>
          Enter the start date and end date of the qualification
        </span>
        <div className={s.dateInputBlock}>
          <div className={s.dateInput}>
            <MuiDatePicker
              value={
                addQualification.qualificationToSave.membershipStart
                  ? dayjs(addQualification.qualificationToSave.membershipStart)
                  : qualificationToUpdate &&
                    qualificationToUpdate.membershipStart?.length > 0
                  ? dayjs(new Date(qualificationToUpdate!.membershipStart))
                  : undefined
              }
              setValue={(value: Dayjs | null) =>
                setAddQualification((prev) => ({
                  ...prev,
                  qualificationToSave: {
                    ...prev.qualificationToSave,
                    membershipStart: value?.toDate(),
                  },
                }))
              }
            />
          </div>
          <div className={s.dateInput}>
            <MuiDatePicker
              value={
                addQualification.qualificationToSave.membershipEnd
                  ? dayjs(addQualification.qualificationToSave.membershipEnd)
                  : qualificationToUpdate &&
                    qualificationToUpdate.membershipEnd?.length > 0
                  ? dayjs(new Date(qualificationToUpdate!.membershipEnd))
                  : undefined
              }
              setValue={(value: Dayjs | null) =>
                setAddQualification((prev) => ({
                  ...prev,
                  qualificationToSave: {
                    ...prev.qualificationToSave,
                    membershipEnd: value?.toDate(),
                  },
                }))
              }
            />
          </div>
        </div>
      </div>
      <div className={s.uploadCertificateBlock}>
        <span className={s.headLable}>Certificate</span>
        <span className={s.secondLable}>
          Add a certificate in image or pdf format
        </span>
        <div className={s.uploadFilesActionBlock}>
          {addQualification.qualificationToSave.file && (
            <div>{addQualification.qualificationToSave.file.name}</div>
          )}
          <label className={s.fileInputBlock}>
            <input
              style={{ display: "none" }}
              type="file"
              accept={[...imageExtensions, ...documentExtensions].join(", ")}
              multiple={false}
              onChange={handleCertificateChange}
            />
            {addQualification.qualificationToSave.file ? (
              <span className={s.updateAvatarBtn} role="button">
                <EditIcon />
                <span>Replace</span>
              </span>
            ) : (
              <div className={s.addCertificateBtn}>
                <PlusIcon />
                <span>Add certificate</span>
              </div>
            )}
          </label>
        </div>
      </div>
      <StandartButton
        action={updateQualification}
        buttonTitle={"Save"}
        width="100%"
        disabled={!validationNewCertificate()}
      />
    </div>
  );
};

export default QualificationsCertificates;
